import { createAsyncThunk } from '@reduxjs/toolkit';
import { DataRoomUploadWarning } from '../models/data-room-upload-warning.model';

export interface GetDataRoomUploadWarningRequest {
    projectId: number;
}

export const GetDataRoomUploadWarning = createAsyncThunk(
    'dataRoom/getUploadWarning',
    async (
        { projectId }: GetDataRoomUploadWarningRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        const response = await axios.get(
            `api/dataRequestProject/${projectId}/data-room-upload-warning`
        );

        return response.data as DataRoomUploadWarning;
    }
);
